import { createRouter, createWebHistory } from 'vue-router'
import frontendRoutes from './frontend'
import userRoutes from './user'
import vendorRoutes from './vendor'
import { getAuthRole, isAuthenticated } from '@/services/auth'

const routes = [
    ...frontendRoutes,
    ...userRoutes,
    ...vendorRoutes,
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/views/frontend/NotFound.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  const authRole = getAuthRole()
  const allowedRole = to.meta.allowedRole
  if (allowedRole && authRole && allowedRole !== authRole) {
    next(authRole === 'vendor' ? { path: '/dashboard' } : { path: '/host' })
    return
  }
  next()
})

export default router
